import { render, staticRenderFns } from "./editableWidgetItem.vue?vue&type=template&id=3e5a9ed8&scoped=true&"
import script from "./editableWidgetItem.vue?vue&type=script&lang=js&"
export * from "./editableWidgetItem.vue?vue&type=script&lang=js&"
import style0 from "./editableWidgetItem.vue?vue&type=style&index=0&id=3e5a9ed8&prod&scoped=true&lang=css&"
import style1 from "./editableWidgetItem.vue?vue&type=style&index=1&id=3e5a9ed8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5a9ed8",
  null
  
)

export default component.exports